import { render, staticRenderFns } from "./AuthFoot.vue?vue&type=template&id=301fc462&scoped=true"
import script from "./AuthFoot.vue?vue&type=script&lang=js"
export * from "./AuthFoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301fc462",
  null
  
)

export default component.exports